/**
 * 格式化时间
 * @param date 时间对象
 * @param fmt 格式，如：yyyy-MM-dd hh:mm:ss
 * @return {String} 格式化时间
 */
export function formatDate(date, fmt = 'yyyy-MM-dd') {
  if (!date) {
    return '';
  }
  if (typeof date !== 'object') {
    date = new Date(date);
  }
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
  }
  const o = {
    'M+': date.getMonth() + 1,
    'd+': date.getDate(),
    'h+': date.getHours(),
    'm+': date.getMinutes(),
    's+': date.getSeconds()
  };
  for (const k in o) {
    if (new RegExp(`(${k})`).test(fmt)) {
      const str = o[k] + '';
      fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? str : padLeftZero(str));
    }
  }
  return fmt;
}

/**
 * 自动补0
 * @param str 需要补0的字符串
 */
function padLeftZero(str) {
  return ('00' + str).substr(str.length);
}